import { insertScriptAsync, removeNode } from "../functions";

const honeybadgerConfig = window.ENV.HONEYBADGER_CONFIG;

let HoneybadgerDOMNode;

const configureHoneybadgerInstance = () => {
  if (!window.Honeybadger) {
    return;
  }

  window.Honeybadger.configure({
    apiKey: honeybadgerConfig.apiKey,
    environment: honeybadgerConfig.environment,
  });

  window.Honeybadger.beforeNotify((notice) => {
    if (
      honeybadgerConfig.environment === "production" &&
      !new RegExp(honeybadgerConfig.originStack).test(notice.stack)
    ) {
      return false;
    }

    return true;
  });
};

export const setupHoneybadger = () => {
  if (window.Honeybadger) {
    return;
  }

  if (!honeybadgerConfig.isEnabled && !honeybadgerConfig.isLiveSessionEnabled) {
    return;
  }

  insertScriptAsync({ url: honeybadgerConfig.url, crossOrigin: "" })
    .then((scriptNode) => {
      HoneybadgerDOMNode = scriptNode;
      configureHoneybadgerInstance();
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const setupHoneybadgerSync = () => {
  if (window.Honeybadger) {
    return null;
  }

  if (!honeybadgerConfig.isEnabled && !honeybadgerConfig.isLiveSessionEnabled) {
    return null;
  }

  return insertScriptAsync({ url: honeybadgerConfig.url, crossOrigin: "" })
    .then((scriptNode) => {
      HoneybadgerDOMNode = scriptNode;
      configureHoneybadgerInstance();
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export const removeHoneybadger = () => {
  if (!HoneybadgerDOMNode) {
    return;
  }

  delete window.Honeybadger;
  removeNode(HoneybadgerDOMNode);
};
